import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { getCurrencies } from "../api"
import type { CurrenciesQueryParams, CurrenciesResponse } from "../types"

export function useCurrencies(
  params: CurrenciesQueryParams = {},
  options?: Omit<UseQueryOptions<CurrenciesResponse>, "queryKey" | "queryFn">
) {
  return useQuery({
    queryKey: ["currencies", params],
    queryFn: () => getCurrencies(params),
    ...options,
  })
}
